import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/41d95ddd-5b5f-4d51-8378-ac8ba11c30a2";
export const REGISTER_URL = "https://a.ntrk2.com/6c857f04-ebe7-415a-95b1-af2a157450fc";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://ezezph.loadprkw2a.com/download?openExternalBrowser=1&id=rd1e7iachvu7mbr";

export * from "./codes";
export * from "./context";
